export const I18N_LANGUAGES = ['en', 'de'];
export const I18N_FALLBACK_LNG = 'en';
